import React, { useState } from "react";
import {
  Box,
  Paper,
} from "@mui/material";
import VehicleDetails from "./vehicleDetails/VehicleDetails";
import VehicleSubmission from "./vehicle-submission/VehicleSubmission";

export default function AddVehicle({onSubmit}:any) {
  const [step, setStep] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    vehicleRegistrationNumber: "",
    vehicleNumber: "",
    vehicleType: "",
    branchId: "",
    externalBranchId: "",
    branchLocation: "",
    manufacturerId: "",
    modelId: "",
    vehicleColor: "",
    fleetCategory: "",
    dayDelivery: "",
    materialSource: "",
    currentMileage: "",
    requiredLicenseCode: "",
    requiresPdp: false,
  });

  const renderStepContent = () => {
    switch (step) {
      case 1:
        return (
          <VehicleDetails
            setStep={setStep}
            setFormData={setFormData}
            formData={formData}
            setIsLoading={setIsLoading}
            isLoading={isLoading}
          />
        );
      case 2:
        return <VehicleSubmission 
               onHomeClick={onSubmit}
        />;

      default:
        return null;
    }
  };

  return <Box>
      <Paper
          elevation={0}
          sx={{
            p: 4,
            borderRadius: 3,
            backgroundColor: "#fff",
          }}
        >
           {renderStepContent()}
        </Paper>
   </Box>;
}
